import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-video-chapter.scss';

@customElement('vm-video-chapter')
export class VmVideoChapter extends LitElement {
    static override styles = Styles;

    @property({ type: String })
    thumbnailSrc = '';

    @property({ type: Number })
    timestampStart = 0;

    @property({ type: Number })
    timestampEnd = 0;

    @property({ type: Number })
    ordinalNumber?: number;

    @property({ type: String })
    override title = '';

    override connectedCallback() {
        super.connectedCallback();

        this.setAttribute('role', 'listitem');
    }

    get duration() {
        const durationMs = this.timestampEnd - this.timestampStart;
        const totalSeconds = Math.round(durationMs / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        return `${minutes > 0 ? minutes + 'm ' : ''}${seconds > 0 ? seconds + 's' : ''}`.trim();
    }

    override render() {
        return html`
            <div class="video-chapter-preview">
                <img class="video-chapter-preview__thumbnail" src="${this.thumbnailSrc}" alt="${this.title}" />
                <div class="video-chapter-preview__duration">${this.duration}</div>
            </div>
            <div class="video-chapter-title" data-testid="video-chapter-title">
                <span class="video-chapter-title__ordinal">${this.ordinalNumber}.</span>
                ${this.title}
            </div>
        `;
    }
}
